// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"detail_wrapper__1Rmfn","header":"detail_header__3lQvr","west":"detail_west__3nfU3","east":"detail_east__2LiWr"};